const initialState = {
    images: []
  };
  
  const imageReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'ADD_IMAGE':
        return {
         ...state,
          images: [...state.images, action.payload]
        };
      case 'DELETE_FILE_SUCCESS':
        return {
          ...state,
          images: state.images.filter(image => image.fileId !== action.payload)
        };
      default:
        return state;
    }
  };

  export default imageReducer;